import { useMutation } from '@tanstack/react-query'
import { useNotification } from 'components/Notification'
import {
  createCustomerLocation,
  updateCustomerLocation,
  deleteCustomerLocation,
} from 'services/customerLocations'

function useCustomerLocation({ onSaveLocationSuccess, onRemoveLocationSuccess }) {
  const { createNotification } = useNotification()

  const { mutate: saveLocation, isPending: isSaving } = useMutation({
    mutationFn: ({ locationId, customerId, existingLocationId }) =>
      existingLocationId
        ? updateCustomerLocation({ id: existingLocationId, locationId })
        : createCustomerLocation({ customerId, locationId }),
    onSuccess: location => {
      onSaveLocationSuccess(location)
      createNotification({ message: 'Location saved', variant: 'success' })
    },
    onError: error => {
      const message =
        error?.response?.data?.errors?.[0]?.message ||
        error?.response?.data?.errors?.[0] ||
        'Failed to save location'
      createNotification({ message, variant: 'error' })
    },
  })

  const { mutate: removeLocation, isPending: isRemoving } = useMutation({
    mutationFn: ({ existingLocationId }) => deleteCustomerLocation(existingLocationId),
    onSuccess: () => {
      onRemoveLocationSuccess()
      createNotification({ message: 'Location removed', variant: 'success' })
    },
    onError: () => {
      createNotification({ message: 'Failed to remove location', variant: 'error' })
    },
  })

  return { saveLocation, removeLocation, isSaving, isRemoving }
}

export default useCustomerLocation
